<h2 class="title">
    Leads
</h2>
<p-button label="Add new" routerLink="/management/create-contact-request"></p-button>
<div>
    <div class="top-bar">
        <div class="ui-inputgroup" [formGroup]="searchForm" *ngIf="searchForm">
            <input pInputText formControlName="searchTerm" placeholder="search by name">
            <span class="ui-inputgroup-addon"><i class="pi pi-search" style="line-height: 1.25;"></i></span>
          </div>
        <div class="select-button-container">
            <p-selectButton [options]="displayOptions" [(ngModel)]="selectedDisplayOption" (onChange)="updateView()">
            </p-selectButton>
          </div>
    </div>
</div>
<ng-container *ngIf="filteredRequests | async as data">
    <p-table selectionMode="single" [value]="data" *ngIf="searchForm">
        <ng-template pTemplate="header">
            <tr>
                <th [style]="{width: '80px'}">
                    ID
                </th>
                <th>
                    Lead Type
                </th>
                <th [style]="{width: '150px'}">
                    Name
                </th>
                <th>
                    Message
                </th>
                <th [style]="{width: '120px'}">
                    Phone 📞
                </th>
                <th [style]="{width: '250px'}">
                    Email 📧
                </th>
                <th [style]="{width: '85px'}">
                    Language
                </th>
                <th [style]="{width: '45px'}">
                    🌍
                </th>
                <th [style]="{width: '100px'}">
                    Interest level
                </th>
                <th [style]="{width: '170px'}">
                    Received
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-request>
            <tr [pSelectableRow]="request" routerLink="/management/wp-contact-request-edit-navigation/{{request.id}}">
                <td>
                    {{request.id}}
                </td>
                <td>
                    {{request.source.leadLabel}}
                </td>
                <td class="name-box">
                    {{request.firstName}} {{request.lastName}}
                </td>
                <td>
                    <div [innerHtml]="request.message" class="message-box">
                    </div>
                </td>
                <td>
                    {{request.phoneNumber}}
                </td>
                <td class="email-box">
                    {{request.email}}
                </td>
                <td>
                    {{request.language.name}}
                </td>
                <td>
                    {{request.isoCode}}
                </td>
                <td>
                    <div [ngClass]="{'hot': request.interestLevel.id==1, 
                    'warm': request.interestLevel.id==2,
                    'cold': request.interestLevel.id==3}">
                    {{request.interestLevel.name | titlecase}}
                    </div>
                </td>
                <td>
                    {{request.created.toDate() | date:"dd/MM/yyyy HH:mm:ss"}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>
